module.exports = __webpack_public_path__ + "static/media/gardenSuites.1269ce56.webp";